import { Component } from '@angular/core';
import { Brewery } from '../../interfaces/brewery';
import { ActivatedRoute, Router } from '@angular/router';
import { BreweriesService } from '../../services/breweries.service';
import { CommonModule } from '@angular/common';
import { MapComponent } from '../map/map.component';
import { Title } from '@angular/platform-browser';
import { Event } from '../../interfaces/event';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInstagram,faTiktok, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { EventCardComponent } from '../event-card/event-card.component';
import { EventsShowcaseComponent } from '../events-showcase/events-showcase.component';
import { faGlobe, faClock } from '@fortawesome/free-solid-svg-icons';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { BranchScheduleComponent } from '../branch-schedule/branch-schedule.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';

const RESTRICTED_EVENT_IDS = [4];

@Component({
  selector: 'app-brewery',
  standalone: true,
  imports: [CommonModule, MapComponent, FontAwesomeModule, EventCardComponent, EventsShowcaseComponent, SkeletonComponent, BranchScheduleComponent, TranslateModule],
  templateUrl: './brewery.component.html',
  styleUrls: ['./brewery.component.scss']
})
export class BreweryComponent {
  brewery: Brewery | null = null;
  events: Event[] = [];
  isLoadingBrewery: boolean = true;
  isLoadingEvents: boolean = true;
  faInstagram = faInstagram;
  faTiktok = faTiktok;
  faFacebook = faFacebook;
  faGlobe = faGlobe;
  faClock = faClock;
  expandedScheduleBranchId: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private breweriesService: BreweriesService,
    private router: Router,
    private title: Title,
    private authService: AuthService
  ){}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const slug = params['slug'];
      this.loadBrewery(slug);
    });
  }

  loadBrewery(slug: string): void {
    this.breweriesService.getBrewery(slug).subscribe(
      breweryData => {
        if(!breweryData) this.router.navigate([''])
        this.title.setTitle('Drink Hopping - ' + breweryData.name)
        this.brewery = breweryData
        this.isLoadingBrewery = false;

        const isAdmin = this.authService.getUser()?.roleId === 2;
        this.events = breweryData.branches
        .flatMap(branch => 
          (branch.eventBranches || [])
            .map(eb => eb.event)
            .filter((e): e is Event => e != null)
        )
        .filter((event, index, self) => 
          index === self.findIndex(e => e.id === event.id)
        )
        .filter(e => isAdmin || !RESTRICTED_EVENT_IDS.includes(e.id));
        this.isLoadingEvents = false;
      },
      error => {
        console.error('Error loading brewery:', error);
        this.isLoadingBrewery = false;
        this.isLoadingEvents = false;
      }
    );
  }

  toggleSchedule(branchId: number): void {
    this.expandedScheduleBranchId = this.expandedScheduleBranchId === branchId ? null : branchId;
  }

  branchHasSchedules(branch: any): boolean {
    return branch.schedules && branch.schedules.length > 0;
  }
}
